/// <reference path="./custom.d.ts" />
/**
 * DS Recoms
 * Recommendation service.
 *
 * OpenAPI spec version: 1.1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


import * as url from "url";
import * as portableFetch from "portable-fetch";
import { Configuration } from "./configuration";

const BASE_PATH = "https://recom.contorion-ds.net".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
    (url: string, init?: any): Promise<Response>;
}

/**
 *
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
    url: string;
    options: any;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected fetch: FetchAPI = portableFetch) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
};

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name: "RequiredError"
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

/**
 *
 * @export
 * @interface Error
 */
export interface Error {
    /**
     * Textual description of the error.
     * @type {string}
     * @memberof Error
     */
    message: string;
    /**
     * Error code of the request:   * `101` - no item found   * `103` - no item ID   * `104` - no user ID   * `105` - internal server error
     * @type {number}
     * @memberof Error
     */
    error: number;
}

/**
 *
 * @export
 * @interface I2iRecom
 */
export interface I2iRecom {
    /**
     * request status message
     * @type {string}
     * @memberof I2iRecom
     */
    message: string;
    /**
     *
     * @type {I2iRecomResults}
     * @memberof I2iRecom
     */
    results: I2iRecomResults;
}

/**
 *
 * @export
 * @interface I2iRecomResults
 */
export interface I2iRecomResults {
    /**
     *
     * @type {Array<I2iRecomResultsItems>}
     * @memberof I2iRecomResults
     */
    items?: Array<I2iRecomResultsItems>;
}

/**
 *
 * @export
 * @interface I2iRecomResultsItems
 */
export interface I2iRecomResultsItems {
    /**
     * product SKU
     * @type {string}
     * @memberof I2iRecomResultsItems
     */
    id?: string;
    /**
     * similarity score
     * @type {number}
     * @memberof I2iRecomResultsItems
     */
    score?: number;
}


/**
 * Item2ItemRecommendationsApi - fetch parameter creator
 * @export
 */
export const Item2ItemRecommendationsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a list of recommendations for a SKU.
         * @summary Retrieve recommendations for a SKU
         * @param {string} iid SKU for which recoms are to be retrieved.
         * @param {string} uid User ID on which behalf recoms are to be retrieved.
         * @param {number} [ni] Number of recoms to retrieve.
         * @param {number} [v] Defines level of verbosity:   * 0 - normal mode   * 1 - verbose mode
         * @param {number} [utype] User type to specify what kind of recoms are to be retrieved:    * 0 - when the customer theme is b2b   * 1 - when the customer theme is b2c   * 2 - when no theme is selected
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        i2iV1Get(iid: string, uid: string, ni?: number, v?: number, utype?: number, options: any = {}): FetchArgs {
            // verify required parameter 'iid' is not null or undefined
            if (iid === null || iid === undefined) {
                throw new RequiredError('iid','Required parameter iid was null or undefined when calling i2iV1Get.');
            }
            // verify required parameter 'uid' is not null or undefined
            if (uid === null || uid === undefined) {
                throw new RequiredError('uid','Required parameter uid was null or undefined when calling i2iV1Get.');
            }
            const localVarPath = `/i2i/v1/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (iid !== undefined) {
                localVarQueryParameter['iid'] = iid;
            }

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }

            if (ni !== undefined) {
                localVarQueryParameter['ni'] = ni;
            }

            if (v !== undefined) {
                localVarQueryParameter['v'] = v;
            }

            if (utype !== undefined) {
                localVarQueryParameter['utype'] = utype;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Item2ItemRecommendationsApi - functional programming interface
 * @export
 */
export const Item2ItemRecommendationsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Returns a list of recommendations for a SKU.
         * @summary Retrieve recommendations for a SKU
         * @param {string} iid SKU for which recoms are to be retrieved.
         * @param {string} uid User ID on which behalf recoms are to be retrieved.
         * @param {number} [ni] Number of recoms to retrieve.
         * @param {number} [v] Defines level of verbosity:   * 0 - normal mode   * 1 - verbose mode
         * @param {number} [utype] User type to specify what kind of recoms are to be retrieved:    * 0 - when the customer theme is b2b   * 1 - when the customer theme is b2c   * 2 - when no theme is selected
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        i2iV1Get(iid: string, uid: string, ni?: number, v?: number, utype?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<I2iRecom> {
            const localVarFetchArgs = Item2ItemRecommendationsApiFetchParamCreator(configuration).i2iV1Get(iid, uid, ni, v, utype, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * Item2ItemRecommendationsApi - factory interface
 * @export
 */
export const Item2ItemRecommendationsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Returns a list of recommendations for a SKU.
         * @summary Retrieve recommendations for a SKU
         * @param {string} iid SKU for which recoms are to be retrieved.
         * @param {string} uid User ID on which behalf recoms are to be retrieved.
         * @param {number} [ni] Number of recoms to retrieve.
         * @param {number} [v] Defines level of verbosity:   * 0 - normal mode   * 1 - verbose mode
         * @param {number} [utype] User type to specify what kind of recoms are to be retrieved:    * 0 - when the customer theme is b2b   * 1 - when the customer theme is b2c   * 2 - when no theme is selected
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        i2iV1Get(iid: string, uid: string, ni?: number, v?: number, utype?: number, options?: any) {
            return Item2ItemRecommendationsApiFp(configuration).i2iV1Get(iid, uid, ni, v, utype, options)(fetch, basePath);
        },
    };
};

/**
 * Item2ItemRecommendationsApi - object-oriented interface
 * @export
 * @class Item2ItemRecommendationsApi
 * @extends {BaseAPI}
 */
export class Item2ItemRecommendationsApi extends BaseAPI {
    /**
     * Returns a list of recommendations for a SKU.
     * @summary Retrieve recommendations for a SKU
     * @param {string} iid SKU for which recoms are to be retrieved.
     * @param {string} uid User ID on which behalf recoms are to be retrieved.
     * @param {number} [ni] Number of recoms to retrieve.
     * @param {number} [v] Defines level of verbosity:   * 0 - normal mode   * 1 - verbose mode
     * @param {number} [utype] User type to specify what kind of recoms are to be retrieved:    * 0 - when the customer theme is b2b   * 1 - when the customer theme is b2c   * 2 - when no theme is selected
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Item2ItemRecommendationsApi
     */
    public i2iV1Get(iid: string, uid: string, ni?: number, v?: number, utype?: number, options?: any) {
        return Item2ItemRecommendationsApiFp(this.configuration).i2iV1Get(iid, uid, ni, v, utype, options)(this.fetch, this.basePath);
    }

}

